import { ListSubheader, Menu, MenuItem } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import styled from 'styled-components/macro';
import api from 'api/call';
import { APP_FORM_STATUS_NOT_MATCH } from 'utility/frontendMessage';
import useDialog from 'components/ConfirmDialog/useDialog';

const SLayout = styled.div`
    cursor: pointer;
    display: flex;
    justify-content: center;
`;

const MenuAction = ({ actions, row, checkBackEndStatus = false, documentType = 'Initail' }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const userRole = useSelector((state) => state.user.role);
    const {
        page = 1,
        pageSize = 10,
        isDesc = true,
        sort = 'updateDtm',
        folder,
    } = useSelector((state) => state.application);
    const dataQ = useSelector((state) => state.application);
    const {
        page: postPage = 1,
        pageSize: postPageSize = 10,
        isDesc: postIsDesc = true,
        sort: postSort = 'updateDtm',
        folder: postFolder,
    } = useSelector((state) => state.postApproval);
    const [currentMenuType, setCurrentMenuType] = useState('');
    const history = useHistory();
    const showDialog = useDialog();
    const handleMenuClick = (event, type) => {
        setCurrentMenuType(type);
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleBackEndStatus = async (index) => {
        const { showInStatus: status, text: actionText } = actions[index];
        if (status && actionText === 'Request for Return') {
            let res;
            if (documentType === 'Initail') {
                res = await api.application.getApplication({
                    page,
                    pageSize,
                    isDesc,
                    sort,
                    folder,
                });
            } else {
                res = await api.approval.getPostApprovalDocument({
                    page: postPage,
                    pageSize: postPageSize,
                    isDesc: postIsDesc,
                    sort: postSort,
                    folder: postFolder,
                });
            }
            const applicationResult = res.data.result.result;
            let buttonStatus = typeof status !== 'object' ? [status] : status;
            let lastStatus = null;
            let reportId = row.id || null;
            applicationResult?.forEach((data) => {
                if (data.id === reportId) {
                    console.log('data.statusId: ', data.statusId);
                    lastStatus = data.statusId;
                }
            });
            if (!buttonStatus.includes(lastStatus)) {
                showDialog({
                    description: APP_FORM_STATUS_NOT_MATCH,
                    isError: true,
                    disableCancelButton: true,
                });
                return false;
            }
            return true;
        }
        return true;
    };

    return (
        <SLayout>
            <MoreVert onClick={(e) => handleMenuClick(e, row.id)} />
            <Menu
                anchorEl={anchorEl}
                keepMounted
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={Boolean(anchorEl) && currentMenuType === row.id}
                onClose={handleMenuClose}
            >
                {actions?.map((item, index) => {
                    if (item?.shouldHidden?.(row, userRole)) {
                        return null;
                    }

                    const extraProps = {};

                    extraProps.onClick = async () => {
                        if (item.beforeAction) {
                            await item.beforeAction();
                        }

                        if (item.path) {
                            history.push(item.path);
                        } else {
                            if (item?.action) {
                                if (checkBackEndStatus) {
                                    const status = await handleBackEndStatus(index);
                                    if (status) {
                                        item.action?.({ row });
                                    }
                                } else {
                                    item.action?.({ row });
                                }
                            }

                            handleMenuClose();
                        }
                    };

                    return (
                        <div key={`${item.text}-${index}`}>
                            {item.group && (
                                <ListSubheader style={{ fontWeight: 'bold', background: '#f3f3f3' }}>
                                    {item.group}
                                </ListSubheader>
                            )}
                            <MenuItem {...extraProps}>{item.text}</MenuItem>
                        </div>
                    );
                })}
            </Menu>
            {actions.map((item, index) => {
                if (!item.customDialog) {
                    return null;
                }

                const CustomDialog = item.customDialog;

                return (
                    <div key={index}>
                        <CustomDialog />
                    </div>
                );
            })}
        </SLayout>
    );
};

export default MenuAction;
